// extracted by mini-css-extract-plugin
module.exports = {"buttonWrap":"ButtonSlice_buttonWrap__cf360","left":"ButtonSlice_left__adfc1","right":"ButtonSlice_right__6eb8a","center":"ButtonSlice_center__ff970"};